import { create } from 'zustand';
import { DEFAULT_CHART_COLORS } from '../../../enums';

export const useShowUploadFileTutorial = create((set) => ({
  showTutorial: false,
  setShowTutorial: (showTutorial: boolean) => set(() => ({ showTutorial: showTutorial }))
}));

interface ProjectNumbersStore {
  numProjects: number;
  setNumProjects: (numProjects: number) => void;
}

export const useProjectNumbers = create<ProjectNumbersStore>((set, get) => ({
  numProjects: 0,
  setNumProjects: (numProjects: number) => {
    set({ numProjects });
  }
}));
export const useShowConfigTutorial = create((set) => ({
  showTutorial: false,
  setShowTutorial: (showTutorial: boolean) => set(() => ({ showTutorial: showTutorial }))
}));

export const useDynamicTextErrorModal = create((set) => ({
  headerTextForNoPlan: '',
  setHeaderTextForNoPlan: (headerTextForNoPlan: string) =>
    set(() => ({ headerTextForNoPlan: headerTextForNoPlan }))
}));

export const useGenericErrorModal = create((set) => ({
  genericError: false,
  setGenericError: (genericError: boolean) => set(() => ({ genericError: genericError }))
}));

export const useFileUploaded = create((set) => ({
  isFileUploaded: false,
  setIsFileUploaded: (isFileUploaded: boolean) => set(() => ({ isFileUploaded: isFileUploaded }))
}));

export const useTrialExpired = create((set) => ({
  trialExpired: false,
  setTrialExpired: (trialExpired: boolean) => set(() => ({ trialExpired: trialExpired }))
}));

export const useShowsModalError = create((set) => ({
  showModalError: false,
  setShowModalError: (showModalError: boolean) => set(() => ({ showModalError: showModalError }))
}));

export const useHasAccountRestrictions = create((set) => ({
  hasRestrictions: false,
  setHasRestrictions: (hasRestrictions: boolean) =>
    set(() => ({ hasRestrictions: hasRestrictions }))
}));

export const useActivateInteractiveModules = create((set) => ({
  activate: false,
  setActivate: (activate: boolean) => set(() => ({ activate: activate }))
}));

export const useDownloadDocumentStatus = create((set) => ({
  downloading: false,
  setDownloading: (downloading: boolean) => set(() => ({ downloading: downloading }))
}));

export const useNavigationMenu = create((set) => ({
  navigation: 'new-file',
  setNavigation: (navigation: boolean) => set(() => ({ navigation: navigation }))
}));

export const useFileDetails = create((set) => ({
  fileSelected: null,
  setFileSelected: (fileSelected: any) => set(() => ({ fileSelected: fileSelected }))
}));

export const unSaveChangesSettingsModal = create((set) => ({
  unSaveChangesModal: false,
  setUnSaveChangesModal: (unSaveChangesModal: boolean) =>
    set(() => ({ unSaveChangesModal: unSaveChangesModal }))
}));

export const useConfirmSettingsModal = create((set) => ({
  confirmModal: false,
  setConfirmModal: (confirmModal: boolean) => set(() => ({ confirmModal: confirmModal }))
}));

export const useCancelSettingsModal = create((set) => ({
  cancelModal: false,
  setCancelModal: (cancelModal: boolean) => set(() => ({ cancelModal: cancelModal }))
}));

export const useMenuBar = create((set) => ({
  openMenu: false,
  setOpenMenu: (openMenu: boolean) => set(() => ({ openMenu: openMenu }))
}));

export const useCustomChartSelected = create((set) => ({
  isCustomChart: false,
  setIsCustomChart: (isCustomChart: boolean) => set(() => ({ isCustomChart: isCustomChart }))
}));

interface WorkspaceStore {
  currentWorkspace: string;
  setCurrentWorkspace: (url: string) => void;
  clearWorkspace: () => void;
}

export const useWorkspaceStore = create<WorkspaceStore>((set) => ({
  currentWorkspace: '',
  setCurrentWorkspace: (url: string) => set({ currentWorkspace: url }),
  clearWorkspace: () => set({ currentWorkspace: '' })
}));

interface LastPageStore {
  lastPage: string;
  setLastPage: (url: string) => void;
  clearLastPage: () => void;
}

export const useLastPageStore = create<LastPageStore>((set) => ({
  lastPage: '',
  setLastPage: (lastPage: string) => set({ lastPage: lastPage }),
  clearLastPage: () => set({ lastPage: '' })
}));

export const useShowManageAccount = create((set) => ({
  showStripeLink: true,
  setShowStripeLink: (showStripeLink: boolean) => set(() => ({ showStripeLink: showStripeLink }))
}));

export const useNewLillyClaim = create((set) => ({
  newLillyClaim: false,
  setNewLillyClaim: (newLillyClaim: boolean) => set(() => ({ newLillyClaim: newLillyClaim }))
}));

export const useShowUpgradeLoader = create((set) => ({
  showLoader: false,
  setShowLoader: (showLoader: boolean) => set(() => ({ showLoader: showLoader }))
}));

export const useSetGenericError = create((set) => ({
  showGenericError: false,
  setShowGenericError: (showGenericError: boolean) =>
    set(() => ({ showGenericError: showGenericError }))
}));

export const useReportsMenuWithAllExcluded = create((set) => ({
  allExcluded: false,
  setAllExcluded: (allExcluded: boolean) => set(() => ({ allExcluded: allExcluded }))
}));

export const useCohortsMenuWithAllExcluded = create((set) => ({
  allExcluded: false,
  setAllExcluded: (allExcluded: boolean) => set(() => ({ allExcluded: allExcluded }))
}));

export const useCorrelationsMenuWithAllExcluded = create((set) => ({
  allExcluded: false,
  setAllExcluded: (allExcluded: boolean) => set(() => ({ allExcluded: allExcluded }))
}));

export const useSignalsMenuWithAllExcluded = create((set) => ({
  allExcluded: false,
  setAllExcluded: (allExcluded: boolean) => set(() => ({ allExcluded: allExcluded }))
}));

export const useDeactivateMenu = create((set) => ({
  deactivate: false,
  setDeactivate: (deactivate: boolean) => set(() => ({ deactivate: deactivate }))
}));

interface MyFilesStore {
  myFilesData: any[];
  setMyFilesData: (data: any[]) => void;
  clearMyFiles: () => void;
}

export const useMyFilesData = create<MyFilesStore>((set) => ({
  myFilesData: [],
  setMyFilesData: (data) => set(() => ({ myFilesData: data })),
  clearMyFiles: () => set(() => ({ myFilesData: [] }))
}));

export const useOpenCustomChartColors = create((set) => ({
  showColors: false,
  setShowColors: (showColors: boolean) => set(() => ({ showColors: showColors }))
}));

export const useChartColors = create((set) => ({
  colors: DEFAULT_CHART_COLORS,
  setColors: (colors: string[]) => set(() => ({ colors: colors }))
}));

export const useShowChartLabel = create((set) => ({
  showLabels: false,
  setShowLabels: (showLabels: boolean) => set(() => ({ showLabels: showLabels }))
}));

export const useHasBasicConfig = create((set) => ({
  config: null,
  setConfig: (config: any) => set(() => ({ config: config }))
}));

export const useShowGlobalConfig = create((set) => ({
  globalConfig: false,
  setGlobalConfig: (globalConfig: boolean) => set(() => ({ globalConfig: globalConfig }))
}));
